import { Logo, OneLogo, WhiteLogo } from "@/components/Icons/Icons";
import { useAppSelector } from "@/hooks/types";
import { getIs1TemplateTenant, getTenant } from "@/store/tenant/selectors";
import { ITenantImageConfig } from "@/types/tenant";

interface TenantImageProps {
    imageType: keyof ITenantImageConfig;
    alt?: string;
    className?: string;
}

export const TenantImage: React.FC<TenantImageProps> = ({
    imageType,
    alt,
    className,
}) => {
    const tenant = useAppSelector(getTenant);
    const is1TemplateTenant = useAppSelector(getIs1TemplateTenant);

    if (!tenant) {
        return null;
    }

    if (is1TemplateTenant) {
        switch (imageType) {
            case "primaryLogo":
                return <Logo className={className} />;
            case "mobileLogo":
                return <OneLogo className={className} />;
            case "footerLogo":
                return <WhiteLogo className={className} />;
            default:
                return null;
        }
    }

    const imageUrl = tenant.images[imageType];

    return (
        <img
            src={imageUrl}
            alt={alt}
            className={className}
        />
    );
};
